import axios from 'axios'
import baseService from './baseService'

const roServiceService = {
  getRoServiceInformation (token) {
    return axios.get('roservicemcd/getroserviceinformation', {
      params: {
        token: token
      }
    })
  },
  updateServiceVehicleWashingStatus (vehicleWashingStatusModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve({})
      } else {
        axios
          .post('/roservicemcd/updateservicevehiclewashingstatus', vehicleWashingStatusModel, baseService.defaultConfig, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  updateServiceVehicleValetStatus (vehicleValetStatusModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve({})
      } else {
        axios
          .post('/roservicemcd/updateservicevehiclevaletstatus', vehicleValetStatusModel, baseService.defaultConfig, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  }
}

export default roServiceService
